import { render } from "./IgnisLogo.vue?vue&type=template&id=4eeea578"
import script from "./IgnisLogo.vue?vue&type=script&lang=js"
export * from "./IgnisLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__